import React, { useContext, useEffect } from 'react';
import { TouchableOpacity, Text, StyleSheet } from "react-native";
import { AppControlContext } from 'app/contexts/AppControlContext';
import { Icon } from '@material-ui/core';

export default function Toggle(props) {
  const { onPress } = props
  const { isAppControl } = useContext(AppControlContext)

  return (
    <TouchableOpacity
      style={!isAppControl? styles.container:stylesTypeB.container}
      onPress={onPress}
    >
      <Icon color={!isAppControl?'white':"primary"} >expand_more</Icon>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  container: {
    borderWidth: 0.5,
    padding: 1,
    borderRadius: 5,
    borderColor: 'white'
  },
  label: {
    fontSize: 20,
    color: 'white'
  }
})

const stylesTypeB = StyleSheet.create({
  container: {
    borderWidth: 0.5,
    padding: 1,
    borderRadius: 5,
    borderColor: '#000000'
  },
  label: {
    fontSize: 20,
    color: '#000000'
  }
})